import { render, staticRenderFns } from "./SnackBarErrorIcon.vue?vue&type=template&id=a8b22504"
import script from "./SnackBarErrorIcon.vue?vue&type=script&lang=js"
export * from "./SnackBarErrorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports